var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlavor9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.17206 6.73091C2.17206 7.48659 1.01996 7.48659 1.01996 6.73091V0.970414H6.80936C7.56504 0.970414 7.56504 2.12251 6.80936 2.12251H2.17206V6.73091ZM11.7481 6.73091C11.7481 7.48659 10.596 7.48659 10.596 6.73091V0.970414H16.3854C17.1411 0.970414 17.1411 2.12251 16.3854 2.12251H11.744V6.73091H11.7481ZM11.7481 16.4721C11.7481 17.2278 10.596 17.2278 10.596 16.4721V10.7116H16.3854C17.1411 10.7116 17.1411 11.8968 16.3854 11.8968H11.744V16.4721H11.7481ZM2.17206 16.4721C2.17206 17.2278 1.01996 17.2278 1.01996 16.4721V10.7116H6.80936C7.56504 10.7116 7.56504 11.8968 6.80936 11.8968H2.17206V16.4721ZM0 8.44048H8.45699V0.0495605H0V8.44048ZM9.60909 8.44048H18V0.0495605H9.60909V8.44048ZM18 9.59258H9.60909V17.9505H18V9.59258ZM8.45699 9.59258H0V17.9505H8.45699V9.59258Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.9009,
    fill: "white",
    transform: "translate(0 0.0495605)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlavor9);
export default __webpack_public_path__ + "static/media/flavor_9.5efc46b64bc20cea43b694c3bcb72129.svg";
export { ForwardRef as ReactComponent };